import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

type Props = {
  document: {
    uri: string,
    description: string,
  },
  open: boolean,
  handleClose: () => void,
};

const TutorDocumentModal = ({ document = {}, open, handleClose }: Props) => {
  const actions = [
    <FlatButton label="Close" primary keyboardFocused onClick={handleClose} />,
  ];

  return (
    <div>
      <Dialog
        title={document.description}
        actions={actions}
        modal={false}
        open={open}
        autoScrollBodyContent
        onRequestClose={handleClose}
      >
        <img src={document.uri} alt={document.description} />
      </Dialog>
    </div>
  );
};

export default TutorDocumentModal;



// WEBPACK FOOTER //
// ./src/modules/admin/tutor/components/TutorDocumentModal.js